import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Images from './pages/Images';
import Clinics from './pages/Clinics';
import ClinicDetail from './pages/ClinicDetail';
import Users from './pages/Users';
import Accounts from './pages/Accounts';
import Prompts from './pages/Prompts';
import ProtectedRoute from './components/ProtectedRoute';
import AppNavbar from './components/Navbar';
import { isAdmin, isClinicHead } from './auth';
import 'bootstrap/dist/css/bootstrap.min.css';

const HomeRedirect: React.FC = () => {
    if (isAdmin()) return <><AppNavbar /><Dashboard /></>;
    if (isClinicHead()) return <Navigate to="/clinics" replace />;
    return <Navigate to="/login" replace />;
};

const App: React.FC = () => {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route element={<ProtectedRoute />}>
                    <Route path="/" element={<HomeRedirect />} />
                </Route>
                <Route element={<ProtectedRoute roles={['ROLE_ADMIN']} />}>
                    <Route path="/images" element={<><AppNavbar /><Images /></>} />
                    <Route path="/users" element={<><AppNavbar /><Users /></>} />
                    <Route path="/accounts" element={<><AppNavbar /><Accounts /></>} />
                    <Route path="/prompts" element={<><AppNavbar /><Prompts /></>} />
                </Route>
                <Route element={<ProtectedRoute roles={['ROLE_ADMIN', 'ROLE_CLINIC_HEAD']} />}>
                    <Route path="/clinics" element={<><AppNavbar /><Clinics /></>} />
                    <Route path="/clinics/:orgId" element={<><AppNavbar /><ClinicDetail /></>} />
                </Route>
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    );
};

export default App;
